const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/patientClearing.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

// FIXME: Nothing is handling the action
export const REQUEST_ACTION_TYPES_REQUEST_PATIENT_CLEARING = kisapiActionTypes('PATAPP_SERVICE_REQUEST');

export type PatientClearingRequestData = {
    Patient: {
        family: string;
        given: string;
        birthDate: string;
        mobile: string;
        email: string;
        steet: string;
        postalCode: string;
        city: string;
        country: string;
        sozversnr: string;
    };
    status: string;
    type: string;
    referralID: string;
    speciality: string;
    author: string;
    reservedAppointment: string;
    comments: string;
};

export function requestPatientClearing(patientClearingRequestData: PatientClearingRequestData) {
    const endpoint = `appointments/referral`;
    const body = JSON.stringify(patientClearingRequestData);
    return createPatapiCall(REQUEST_ACTION_TYPES_REQUEST_PATIENT_CLEARING, endpoint, HttpMethod.POST, undefined, body);
}
